var map = {
	"./17122min.jpg": 93,
	"./2.jpg": 132,
	"./2.png": 133,
	"./3d/a3D.png": 84,
	"./3d/b3D.png": 85,
	"./3d/c3D.png": 86,
	"./3d/d3D.png": 87,
	"./3d/e3D.png": 88,
	"./3d/f3D.png": 89,
	"./3d/g3D.png": 90,
	"./Flag_of_Kurdistan2.svg": 134,
	"./Layer 2.png": 135,
	"./Layer 3.png": 136,
	"./WhatsApp Image 2022-09-03 at 11.31.13 AM.jpeg": 137,
	"./buildings.png": 44,
	"./c1.jpg": 67,
	"./c2.jpg": 68,
	"./c3.jpg": 69,
	"./contactus.jpg": 138,
	"./foum.jpg": 70,
	"./goldenLine.jpg": 71,
	"./gt-gate.jpg": 72,
	"./gt.png": 139,
	"./gt7.jpg": 140,
	"./hen.jpg": 141,
	"./hong.jpg": 142,
	"./hong1 (2).jpg": 143,
	"./hong1.jpg": 144,
	"./hong2.jpg": 145,
	"./hong3.jpg": 146,
	"./iraq.svg": 147,
	"./living room-01.jpg": 148,
	"./living room-02.jpg": 149,
	"./living room-03.jpg": 150,
	"./living room-04.jpg": 151,
	"./living room-05.jpg": 152,
	"./living room-06.jpg": 153,
	"./logo-png.png": 37,
	"./s2.jpg": 154,
	"./s3.jpg": 155,
	"./service-center.jpg": 73,
	"./tobias-Flag-of-the-United-Kingdom.svg": 156,
	"./type-a.png": 157,
	"./type-b.png": 158,
	"./type-c.png": 159,
	"./type-d.png": 160,
	"./type-e.png": 161,
	"./type-f.png": 162,
	"./type-g.png": 163,
	"./typeD.jpg": 164,
	"./typeD.png": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;